import { render, staticRenderFns } from "./detail_happiness_tips_page.vue?vue&type=template&id=58c36ab7&scoped=true"
import script from "./detail_happiness_tips_page.vue?vue&type=script&lang=js"
export * from "./detail_happiness_tips_page.vue?vue&type=script&lang=js"
import style0 from "./detail_happiness_tips_page.vue?vue&type=style&index=0&id=58c36ab7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c36ab7",
  null
  
)

export default component.exports